import { deleteAccessToken, removeCookie } from '@backrs_ui/common-ui';

import axios from 'axios';

import { APP_ROUTE } from '../App';
import { ENVIRONMENT } from '../settings';
import { getBackrsToken } from '../utils/tokenHelpers';

// create axios instance for regular api requests
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_LUBAV_API_BASEURL,
});

// request interceptor for injecting token
axiosInstance.interceptors.request.use(async (config) => {
  const accessToken = getBackrsToken();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

// response interceptor for handling 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response.status === 401) {
      deleteAccessToken('backrs_blueprint_token');
      removeCookie(ENVIRONMENT);
      window.location.assign(APP_ROUTE.LOGIN);
    }

    return Promise.reject(error);
  },
);
